import React, { useState } from 'react';
import { useSelector } from 'react-redux'; 
import MainHeaderContainer from 'components/containers/header/MainHeaderContainer'
import MainFeed from 'components/containers/feed/MainFeed';
import FeedSection from 'components/presenters/feed/detail/FeedSection';
import FeedTab from 'components/presenters/feed/detail/FeedTab';

const FeedLayout = ({params, groupNo, type}) => {
    const userInfo = useSelector((state) => {
        return state.userInfo
    })
    const [currTab, setCurrTab] = useState('company');
    const [currType, setCurrType] = useState(type)
    
    const changeCurrentTab = (e) => {
        const newTab = e.currentTarget.getAttribute('data-tab');
        if(newTab === 'normal')
        {
            setCurrType('normal');
        }
        else
        {
            setCurrType('company');
        }
        setCurrTab(newTab);
    }

    const checkUrl = () => {
        return (window.location.href.includes('campaign') || window.location.href.includes('group'));
    }
    
    return (
        <FeedSection>
            {type !== 'campaign' && type !== 'group' ? 
                <MainHeaderContainer title={'피드'}/>
            : null}
            {!checkUrl() && userInfo['role'] === 'company_member' || userInfo['role'] === 'company_admin' ? (<FeedTab currTab={currTab} onChangeTab={changeCurrentTab}/>) : null}
            <MainFeed params={params} groupNo={groupNo} type={currType} />
        </FeedSection>
    );
}


export default FeedLayout;